import { render, staticRenderFns } from "./userFollowers.vue?vue&type=template&id=16b906d1&scoped=true&"
import script from "./userFollowers.vue?vue&type=script&lang=js&"
export * from "./userFollowers.vue?vue&type=script&lang=js&"
import style0 from "./userFollowers.vue?vue&type=style&index=0&id=16b906d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b906d1",
  null
  
)

export default component.exports